import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase'
import NavBar from "../navigationBar";
import { uds } from "../services/userservices";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import MobileNavBar from '../mobileNavigationBar';


function Profile() {
    const [name, setName] = useState('');
    const [isLoaded, setLoaded] = useState(false);
    const [favorites, setFavorites] = useState(<Typography variant="h4" component="h4" m={2}>
                                                  Loading Paths...
                                               </Typography>);

    const navigate = useNavigate();

    useEffect(() => {
        auth.onAuthStateChanged(user => {
            if (user) {
                if (!isLoaded) {
                    const profile = uds.getProfile(auth.currentUser.uid);
                    profile.then((data) => {
                        if (data.exists()) {
                            const favs = data.get("favorites");
                            const listItems = favs.map(fav => fav.split(" "));
                            const favItems = listItems.map(fav => <Button key={fav[0]+fav[1]+fav[2]} variant="contained" color="primary" onClick={() => {navigate(`/${fav[0]}?src=${fav[1]}&dst=${fav[2]}`)}} m={2} style={{margin: "1%"}}>
                                                                    {fav[0] + " " + fav[1] + " \u2192 " + fav[2]}
                                                                </Button>);
                            setFavorites(<ul>{favItems}</ul>);
                        } else {
                            console.log("Document does not exist!");
                        }
                    });
                }
                console.log("loaded favorites");
                setLoaded(true);
                setName(auth.currentUser.displayName);
                
            } else {
                navigate('/login');
            }
        });
    }, []);

    const logout = () => {

        signOut(auth).then(() => {
            console.log('User signed out');
        }).then(() => {
            navigate('/');
        }).catch((error) => {
            console.log("Couldn't sign out");
        });
    }
    
    return (
        <>
            <BrowserView> 
                <NavBar />
                <Typography variant="h8" component="h2" m={2}>
                    Logged in as {name}
                    <Button onClick={logout} variant="contained" color="primary" m={2} style={{marginLeft: "2%"}}>
                        Log Out?
                    </Button>
                </Typography>
                
                <Typography variant="h3" component="h2" m={2}>
                    Favorited Paths:
                </Typography>
                {favorites}
            </BrowserView>
            <MobileView>
            <Typography variant="h8" component="h2" m={2}>
                    Logged in as {name}
                    <Button onClick={logout} variant="contained" color="primary" m={2} style={{marginLeft: "2%"}}>
                        Log Out?
                    </Button>
                </Typography>
                
                <Typography variant="h3" component="h2" m={2}>
                    Favorited Paths:
                </Typography>
                {favorites}
                <MobileNavBar />
            </MobileView>
        </>
    );
}

export default Profile;